import { default as Base } from './base';
import { default as Generic } from './generic';
import { default as Error } from './error';
import { default as TextArea } from './textArea';
export default { Base, Generic, Error, TextArea };
